import { toast } from "react-toastify";
import type { WebsocketEntityModificationMessage } from "@intelligems/ig-types";
import type { QueryClient } from "@tanstack/react-query";
import { experienceKeys, personalizationKeys } from "../api/queryKeys";
import { updateEntityModificationCache } from "./updateEntityModificationCache";
import type { WebsocketMessageHandlerContext } from "./WebsocketMessageHandlerContext";

export function handleEntityModification(
  message: WebsocketEntityModificationMessage,
  context: WebsocketMessageHandlerContext
) {
  const isCurrentEditPageExperience =
    message.experienceId === context.editPageExperienceId;

  if (
    isCurrentEditPageExperience &&
    shouldCheckEditPageUpdateDetection(message, context)
  ) {
    setTimeout(() => {
      context.openDialog("updatedDetected");
    }, 0);
  } else {
    updateEntityModificationCache(message, context.queryClient);
  }

  invalidateEntityModificationLists(message, context.queryClient);

  if (message.message) {
    toast.success(message.message);
  }
}

function shouldCheckEditPageUpdateDetection(
  message: WebsocketEntityModificationMessage,
  context: WebsocketMessageHandlerContext
) {
  return (
    context.isEditPage &&
    !context.isDialogOpen("redirectToPlugin") &&
    !context.ignoreUpdateDetected &&
    !message.testProducts
  );
}

function invalidateEntityModificationLists(
  message: WebsocketEntityModificationMessage,
  queryClient: QueryClient
) {
  if (message.experienceId) {
    void queryClient.invalidateQueries({
      queryKey: experienceKeys.experimentList,
    });
  } else if (message.campaignId) {
    void queryClient.invalidateQueries({
      queryKey: experienceKeys.homeOverviewPersonalizationList,
    });
    void queryClient.invalidateQueries({
      queryKey: personalizationKeys.all(true),
    });
    void queryClient.invalidateQueries({
      queryKey: personalizationKeys.all(false),
    });
  }
}
